/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/components/caed/index.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import omit from 'rc-util/lib/omit';
import Grid from './Grid';
import Meta from './Meta';
import Tabs from '../tabs';
import Row from '../row';
import Col from '../col';
import SizeContext from '../config-provider/SizeContext';
import { ConfigContext } from '../config-provider';
import warning from 'antd/es/_util/warning';
import { Icon } from '../icon';
function getAction(actions, actionSeparator) {
    const actionList = actions.map((action, index) => (
    // eslint-disable-next-line react/no-array-index-key
    React.createElement("li", { style: { width: `${100 / actions.length}%` }, key: `action-${index}` },
        React.createElement("span", null, action),
        actionSeparator && React.createElement(Icon, { className: 'card-action-slash', type: 'slash' }))));
    return actionList;
}
const Card = (props) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const size = React.useContext(SizeContext);
    const onTabChange = (key) => {
        props.onTabChange?.(key);
    };
    const isContainGrid = () => {
        let containGrid;
        // @ts-ignore
        React.Children.forEach(props.children, (element) => {
            if (element && element.type && element.type === Grid) {
                containGrid = true;
            }
        });
        return containGrid;
    };
    const { prefixCls: customizePrefixCls, className, extra, description, headStyle = {}, bodyStyle = {}, title, loading, bordered = false, size: customizeSize, type, cover, coverSizeType = 'rectangle', coverFillType = 'fill', coverBgType, actions, tabList, direction = 'vertical', children, activeTabKey, defaultActiveTabKey, tabBarExtraContent, hoverable, background, borderType = 'shadow1', tabProps = {}, actionSeparator, actionAlign = 'left', ...others } = props;
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const loadingBlockStyle = bodyStyle.padding === 0 || bodyStyle.padding === '0px' ? { padding: 24 } : undefined;
    const block = React.createElement("div", { className: `${prefixCls}-loading-block` });
    if (process.env.NODE_ENV !== 'production')
        warning(!bordered, 'card', `you can use 'borderType = bordered' in B-Design 3.0`);
    const loadingBlock = (React.createElement("div", { className: `${prefixCls}-loading-content`, style: loadingBlockStyle },
        React.createElement(Row, { gutter: 8 },
            React.createElement(Col, { span: 22 }, block)),
        React.createElement(Row, { gutter: 8 },
            React.createElement(Col, { span: 8 }, block),
            React.createElement(Col, { span: 15 }, block)),
        React.createElement(Row, { gutter: 8 },
            React.createElement(Col, { span: 6 }, block),
            React.createElement(Col, { span: 18 }, block)),
        React.createElement(Row, { gutter: 8 },
            React.createElement(Col, { span: 13 }, block),
            React.createElement(Col, { span: 9 }, block)),
        React.createElement(Row, { gutter: 8 },
            React.createElement(Col, { span: 4 }, block),
            React.createElement(Col, { span: 3 }, block),
            React.createElement(Col, { span: 16 }, block))));
    const hasActiveTabKey = activeTabKey !== undefined;
    const extraProps = {
        ...tabProps,
        [hasActiveTabKey ? 'activeKey' : 'defaultActiveKey']: hasActiveTabKey ? activeTabKey : defaultActiveTabKey,
        tabBarExtraContent
    };
    let head;
    const tabs = tabList && tabList.length ? (React.createElement(Tabs, { size: 'large', ...extraProps, className: `${prefixCls}-head-tabs`, onChange: onTabChange }, tabList.map((item) => (React.createElement(Tabs.TabPane, { tab: item.tab, disabled: item.disabled, key: item.key }))))) : null;
    //新增描述dom
    if (title || description || extra || tabs) {
        head = (React.createElement("div", { className: `${prefixCls}-head`, style: headStyle },
            React.createElement("div", { className: `${prefixCls}-head-wrapper` },
                title && React.createElement("div", { className: `${prefixCls}-head-title` }, title),
                extra && React.createElement("div", { className: `${prefixCls}-extra` }, extra)),
            description && React.createElement("div", { className: `${prefixCls}-head-description` }, description),
            tabs));
    }
    const coverDom = cover ? (React.createElement("div", { className: `${prefixCls}-cover ${prefixCls}-cover-${coverSizeType} ${prefixCls}-cover-${coverFillType}` }, loading ? null : (React.createElement("div", { className: classNames({
            [`${prefixCls}-covercontant`]: true,
            [`${prefixCls}-bg-pattern`]: coverBgType === 'pattern'
        }) }, cover)))) : null;
    const body = (React.createElement("div", { className: `${prefixCls}-body`, style: bodyStyle }, loading ? loadingBlock : children));
    //新增底部按钮的排列，默认一个居又，两个平分50%宽度，三个及以上默认按钮宽度
    const actionDom = actions && actions.length ? (React.createElement("ul", { className: `${prefixCls}-actions ${prefixCls}-actions-${actionAlign}` }, getAction(actions, actionSeparator))) : null;
    const divProps = omit(others, ['onTabChange']);
    const mergedSize = customizeSize || size;
    //新增卡片背景颜色的填充
    const backgroundDom = background && typeof background !== 'boolean' ? (React.createElement("div", { className: `${prefixCls}-bg-cover` }, background)) : null;
    const isOnlymeta = () => {
        if (React.Children.count(children) === 1 && React.isValidElement(children)) {
            //@ts-ignore
            return children.type?.name === 'Meta';
        }
    };
    // const mergeBorderTpye = bordered ? 'bordered' : borderType;
    const mergeBorderTpye = bordered ? 'bordered' : borderType;
    const classString = classNames(prefixCls, {
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-hoverable`]: hoverable,
        [`${prefixCls}-contain-grid`]: isContainGrid(),
        [`${prefixCls}-contain-tabs`]: tabList && tabList.length,
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-type-${type}`]: !!type,
        [`${prefixCls}-horizontal`]: direction === 'horizontal',
        [`${prefixCls}-nocover`]: !cover,
        [`${prefixCls}-with-bg`]: background,
        [`${prefixCls}-noaction`]: actionDom === null,
        [`${prefixCls}-bordered`]: mergeBorderTpye === 'bordered',
        [`${prefixCls}-none`]: mergeBorderTpye === 'none',
        [`${prefixCls}-default-shadow`]: mergeBorderTpye === 'shadow1',
        [`${prefixCls}-secondary-shadow`]: mergeBorderTpye === 'shadow2',
        [`${prefixCls}-nobody`]: !children,
        [`${prefixCls}-onlymeta`]: isOnlymeta()
    }, className);
    //新增当方向为horizontal水平时
    if (direction === 'horizontal') {
        return (React.createElement("div", { ...divProps, className: classString },
            backgroundDom,
            coverDom,
            React.createElement("div", { className: `${prefixCls}-content-right` },
                head,
                children && body,
                actionDom)));
    }
    return (React.createElement("div", { ...divProps, className: classString },
        backgroundDom,
        head,
        coverDom,
        children && body,
        actionDom));
};
Card.Grid = Grid;
Card.Meta = Meta;
// const ConfiguredCard = withConfigProvider(Card);
// export { ConfiguredCard as Card };
// export default ConfiguredCard;
export { Card };
export default Card;
